<template>
  <div>
    <div class="py-16 ">
      <v-container>
        <v-row>
        <v-col
          v-for="(card, id) in cards"
          :key="id"
          :cols="$vuetify.breakpoint.mobile ? 12 : 4" 
        >
          <v-card height="200px" class="pa-5 " :class="card.style" elevation="5">
            <v-icon large color="success">{{ card.icon }}</v-icon>
            <h3 class="py-2 " >{{ card.header }}</h3>
            <p>{{ card.text }}</p>
          </v-card>
        </v-col>
      </v-row>
      </v-container>
      
    </div>
  </div>
</template>


<script>
export default {
  name: 'HomeComponent',
  data() {
    return {
      cards: [
        {
          icon: 'mdi-calendar',
          header: 'Efficient Appointment Scheduling',
          text: 'Allow customers to easily book appointments online, minimizing waiting times and improving scheduling accuracy.',
        },
        {
          icon: 'mdi-notebook',
          header: 'Service History Tracking',
          text: 'Maintain detailed records of service history for each vehicle to facilitate future maintenance.',
        },
        {
          icon: 'mdi-tools',
          header: 'Vehicle Diagnostic Tools',
          text: 'Utilize advanced diagnostic tools to quickly identify and resolve vehicle issues, enhancing service quality.'
        },
        {
          icon: 'mdi-engine',
          header: 'Quality Parts Inventory',
          text: 'Access a comprehensive inventory of high-quality auto parts to ensure reliable and durable repairs.'
        },
        {
          icon: 'mdi-bag-personal',
          header: 'Customizable Service Packages',
          text: 'Offer customizable service packages tailored to meet the specific needs of customers and their vehicles.'
        },
        {
          icon: 'mdi-shield-account',
          header: 'Secure Customer Data Handling',
          text: 'Ensure the highest level of security for customer data with robust encryption and privacy protection measures.'
        },
        {
          icon: 'mdi-timetable',
          header: 'Timely Service Updates',
          text: 'Keep customers informed about the progress of their vehicle repairs through automated service updates.'
        },
        {
          icon: 'mdi-bell-ring',
          header: 'Email Notification System',
          text: 'Implement an email notification system for reminders, promotions, and important updates to engage customers effectively.'
        }
      ]
    }
  }
}
</script>


